import { CORRESPONDENCE_TYPES } from "../types/correspondence/correspondencePermissions"
import {
  correspondenceEntityTypesMap,
  nullableInput,
  requiredStringField,
} from "toptaal-shared"
import { z } from "zod"

export const CreateCorrespondenceThreadSchema = z.object({
  category: requiredStringField,
  about: nullableInput(CORRESPONDENCE_TYPES).optional(),
  subject: requiredStringField,
  message: requiredStringField,
  entityType: nullableInput(z.enum(correspondenceEntityTypesMap)).nullable(),
  entityId: nullableInput(z.number()).optional(),

  visibleForTeachers: z.boolean().optional(),
  visibleForOrganizationUsers: z.boolean().optional(),
})

export type CorrespondenceFormValues = z.infer<
  typeof CreateCorrespondenceThreadSchema
>

export type CorrespondenceFormInput = z.input<
  typeof CreateCorrespondenceThreadSchema
>
